import ItemsService from '@/services/items';

export default {
	namespaced: true,
	state: {
		listItem: []
	},

	getters: {
		// async getPemasukan({ commit, state, getters, dispatch }) {
		// 	try {
		// 		const userLogin = JSON.parse(window.localStorage.getItem('user_data'))
		// 		let response
		// 		if (userLogin.role.name == 'accountant') {
		// 			response = await PemasukanService.getPemasukanByType('PEMASUKAN')
		// 			// console.log('response', response)
		// 		} else {
		// 			response = await PemasukanService.getPemasukanByUser()
		// 		}
		// 		return response
		// 	} catch (e) {
		// 		console.log(e)
		// 	}
		// }
	},

	actions: {
		async getRiwayatProduk({ commit, state, getters, dispatch }) {
			let response
			try {
				response = await ItemsService.getRiwayatProduk(JSON.parse(window.localStorage.getItem('category')).id);
			} catch (e) {
				console.log(e);
			}
			return response
		}
	},

	mutations: {
		SET_LIST_ITEM(state, payload) {
			state.listItem = payload;
		},
	}
};
